import { DateRangePickerOption } from 'components/UI/V3/DateRangePicker/DateRangePicker';
import moment from 'moment-timezone';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const useDateRangeOptions = () => {
    const timeZone = useSelector((state: RootState) => state.marketplace.marketplace.schedule.timeZone);

    return useMemo(() => {
        const momentTZ = () => moment().tz(timeZone);

        const todayOption: DateRangePickerOption = {
            label: 'Today',
            value: {
                from: momentTZ().startOf('day'),
                to: momentTZ().endOf('day')
            }
        };

        const tomorrowOption: DateRangePickerOption = {
            label: 'Tomorrow',
            value: {
                from: momentTZ().add(1, 'day').startOf('day'),
                to: momentTZ().add(1, 'day').endOf('day')
            }
        };

        const next7DaysOption: DateRangePickerOption = {
            label: 'Next 7 days',
            value: {
                from: momentTZ().add(1, 'day'),
                to: momentTZ().add(8, 'days')
            }
        };

        const thisMonthOption: DateRangePickerOption = {
            label: 'This month',
            value: {
                from: momentTZ().startOf('month'),
                to: momentTZ().endOf('month')
            }
        };

        const yesterdayOption: DateRangePickerOption = {
            label: 'Yesterday',
            value: {
                from: momentTZ().subtract(1, 'day').startOf('day'),
                to: momentTZ().subtract(1, 'day').endOf('day')
            }
        };

        const last7DaysOption: DateRangePickerOption = {
            label: 'This week',
            value: {
                from: momentTZ().subtract(7, 'days').startOf('day'),
                to: momentTZ().endOf('day')
            }
        };

        const lastMonthOption: DateRangePickerOption = {
            label: 'Last month',
            value: {
                from: momentTZ().subtract(1, 'month').startOf('month'),
                to: momentTZ().subtract(1, 'month').endOf('month')
            }
        };

        const nextMonthOption: DateRangePickerOption = {
            label: 'Next month',
            value: {
                from: momentTZ().add(1, 'month').startOf('month'),
                to: momentTZ().add(1, 'month').endOf('month')
            }
        };

        const last30DaysOption: DateRangePickerOption = {
            label: 'Last 30 days',
            value: {
                from: momentTZ().subtract(30, 'days'),
                to: momentTZ().endOf('day')
            }
        };

        const thisYearOption: DateRangePickerOption = {
            label: 'This year',
            value: {
                from: momentTZ().startOf('year'),
                to: momentTZ().endOf('year')
            }
        };

        const lastYearOption: DateRangePickerOption = {
            label: 'Last year',
            value: {
                from: momentTZ().subtract(1, 'year').startOf('year'),
                to: momentTZ().subtract(1, 'year').endOf('year')
            }
        };

        const nextYearOption: DateRangePickerOption = {
            label: 'Next year',
            value: {
                from: momentTZ().add(1, 'year').startOf('year'),
                to: momentTZ().add(1, 'year').endOf('year')
            }
        };

        const thisWeekOption: DateRangePickerOption = {
            label: 'This Week',
            value: {
                from: momentTZ().startOf('week'),
                to: momentTZ().endOf('week')
            }
        };

        const nextWeekOption: DateRangePickerOption = {
            label: 'Next Week',
            value: {
                from: momentTZ().add(1, 'week').startOf('week'),
                to: momentTZ().add(1, 'week').endOf('week')
            }
        };

        const lastWeekOption: DateRangePickerOption = {
            label: 'Last Week',
            value: {
                from: momentTZ().subtract(1, 'week').startOf('week'),
                to: momentTZ().subtract(1, 'week').endOf('week')
            }
        };

        const allTimeOption: DateRangePickerOption = {
            label: 'All time',
            value: null
        };

        return {
            todayOption,
            tomorrowOption,
            yesterdayOption,
            next7DaysOption,
            last7DaysOption,
            thisMonthOption,
            lastMonthOption,
            nextMonthOption,
            last30DaysOption,
            thisYearOption,
            lastYearOption,
            nextYearOption,
            thisWeekOption,
            nextWeekOption,
            lastWeekOption,
            allTimeOption
        };
    }, [timeZone]);
};
